module.exports = __webpack_public_path__ + "media/images/vehicles/fahrgestelle-fd4db6f204a95e88191cbda7162bee53.png";